import {
  viewButterBarBasedOnUserPreference,
  closeButterBar,
} from "./butter-bar-2.0";

export function initButterBar() {
  viewButterBarBasedOnUserPreference();
  document
    .getElementById("btn-close-butter-bar")
    ?.addEventListener("click", () => closeButterBar());
}

export function initMainNav() {
  const mainNav = document.querySelector("#navigation");
  const ddMenu = document.querySelector("#dropdown-btns-menu");
  const dds = document.querySelector("#nav-dropdowns");

  /** @type {Element | false} */
  let lastOpenDd = false;

  const langPicker = document.querySelector("lang-picker");
  const langPickerCb = langPicker?.querySelector("input");

  const closeNav = () => {
    lastOpenDd = false;
    const openDd = ddMenu?.querySelector(
      "input[name=dropdown-visibility]:checked",
    );
    if (!(openDd instanceof HTMLInputElement)) return;
    openDd.checked = false;
  };

  const closeLangPicker = () => {
    if (langPickerCb instanceof HTMLInputElement) {
      langPickerCb.checked = false;
    }
  };

  const closeAll = () => {
    closeNav();
    closeLangPicker();
  };

  /** @arg {Event} evt */
  const clickOutside = (evt) => {
    const target = evt.target;
    if (!(target instanceof HTMLElement)) return;

    if (!mainNav?.contains(target)) {
      closeAll();
      return;
    }

    if (langPicker?.contains(target)) {
      closeNav();
      return;
    }

    if (mainNav?.contains(target)) {
      closeLangPicker();
      if (!(ddMenu?.contains(target) || dds?.contains(target))) {
        closeNav();
        return;
      }

      const openDd = ddMenu?.querySelector(
        "input[name=dropdown-visibility]:checked",
      );
      if (openDd && target === openDd) {
        if (openDd === lastOpenDd) closeNav();
        else lastOpenDd = openDd;
      }
    }
  };

  document.addEventListener("click", clickOutside);
  closeAll();
}

initButterBar();
initMainNav();
